<template>
  <v-main v-if="liqAdmins.includes(uid)">
    <h1 class="text-center">Liquitousスタッフ用管理画面</h1>
  <v-card
    class="mx-auto text-center"
    max-width="400"
  >
    <v-btn @click="setLid2()">Liquitous管理者登録</v-btn>
    <v-switch
      v-model="idea_loadLimit"
      :label="`アイデア読込制限ボタン設置: ${idea_loadLimit.toString()}`"
      @change="setting('idea_loadLimit',$event)"
    ></v-switch>
    <v-switch
      v-model="project_noticeOpen"
      :label="`プロジェクトお知らせ常時オープン: ${project_noticeOpen.toString()}`"
      @change="setting('project_noticeOpen',$event)"
    ></v-switch>
    <v-switch
      v-model="project_amdOpen"
      :label="`プロジェクト修正提案閉鎖: ${project_amdOpen.toString()}`"
      @change="setting('project_amdOpen',$event)"
    ></v-switch>
    <v-switch
      v-model="idea_submitOpen"
      :label="`アイデア投稿閉鎖: ${idea_submitOpen.toString()}`"
      @change="setting('idea_submitOpen',$event)"
    ></v-switch>
    <v-switch
      v-model="idea_slider"
      :label="`アイデア重要度スライダー: ${idea_slider.toString()}`"
      @change="setting('idea_slider',$event)"
    ></v-switch>
    <v-switch
      v-model="idea_thread"
      :label="`アイデアスレッド: ${idea_thread.toString()}`"
      @change="setting('idea_thread',$event)"
    ></v-switch>
    <v-switch
      v-model="idea_thread_admin_only"
      :disabled="!idea_thread"
      :label="`アイデアスレッド(管理者のみ): ${idea_thread_admin_only.toString()}`"
      @change="setting('idea_thread_admin_only',$event)"
    ></v-switch>
    <v-switch
      v-model="project_sanka"
      :label="`プロジェクト参加者=Lid参加者: ${project_sanka.toString()}`"
      @change="setting('project_sanka',$event)"
    ></v-switch>

    <p>現在のアイデア重要度スライダータイトル：「{{idea_sliderTitle || "(未設定)"}}」</p>
    <div class="d-flex">
      <v-text-field
        v-model="idea_sliderTitleInput"
        label="アイデア重要度スライダー"
        solo
      ></v-text-field>
      <v-btn @click="setting('idea_sliderTitle',idea_sliderTitleInput)">
        保存
      </v-btn>
    </div>
    <v-switch
      v-model="navi_updateDate"
      :label="`更新時刻表示: ${navi_updateDate.toString()}`"
      @change="setting('navi_updateDate',$event)"
    ></v-switch>
  </v-card>
  <v-btn @click="addSortToIdea">
    アイデアにSort追加
  </v-btn>

  </v-main>
</template>

<script>
import firebase from 'firebase'

export default {
  name: 'App',
  data() {
    return {
      db: null,
      config:{},
      liqAdmins: [],
      question: "日本で一番大きい島は？",
      answer: "",

      //機能設定
      idea_loadLimit: false,
      project_noticeOpen:false,
      project_amdOpen:false,
      idea_submitOpen:false,
      idea_slider:false,
      idea_thread:false,
      idea_thread_admin_only:false,
      idea_sliderTitle:"",
      idea_sliderTitleInput:"",
      navi_updateDate:false,
      project_sanka:false,

      //レガシー
      selectMember: [],
      conmem:[],
      conadm:[],
      referendum:[],
      isDele: false,
      admitq: false,
      qn1:0,
      qn2:0,
      qn3:0,
      qn4:0,
      projects:[],
      lidid:[],
      lididadmin:[],
    }
  },
  computed : {
    members(){
      return this.$store.state.members
    },
    namelist(){
      return this.$store.state.namelist
    },
    isAdmin(){
      return this.$store.state.isAdmin
    },
    basetitle(){
      return this.$store.state.basetitle
    },
    lid(){
      return this.$store.state.lid
    },
    alid(){
      return this.$store.state.alid
    },
    lidusers(){
      return this.$store.state.lidusers
    },
    uid() {
      return this.$store.state.auth?.user?.uid || '';
    },
    currentName() {
      return this.$store.state.auth.user.displayName;
    },
    isAuthed() {
      return this.$store.state.auth?.isAuthed;
    },
    admins(){
      return this.$store.state.admins
    },
  },
  created(){
    this.db = firebase.firestore()
    this.$store.dispatch('getLid')
    this.$store.dispatch('getMem')
    this.getLiqAdmin()
    this.getConfig()
  },
  beforeDestroy(){
  },
  methods: {
    setPjNoticeOpen(value){
      if(value) this.$store.commit("setPjNoticeOpen", 0)
      else this.$store.commit("setPjNoticeOpen", 1)
    },
    getLiqAdmin(){
      let self = this
      //全管理者取得
      let collectionA = firebase.firestore().collection("0").doc("config").collection("admins").doc("liq")
      collectionA.get().then((doc) => {
      if (doc.exists) {
        self.liqAdmins = doc.data().admins
        if(self.liqAdmins.includes(self.uid)){
          console.log("Liquitous管理者です")
        }else{
          self.$router.push('/home')
        }
        console.log("liqAdmin data:", doc.data());
      } else {
        console.log("No such document!");
        self.$router.push('/home')
      }
      }).catch((error) => {
        console.log("Error getting document:", error);
      });
    },
    getConfig(){
      let self = this
      let collectionA = firebase.firestore().collection("0").doc("config")
      collectionA.get().then((doc) => {
        self.config = doc.data()
        console.log("Config data:", doc.data());
        if(doc.data().setting&&doc.data().setting.idea_loadLimit){
          self.idea_loadLimit = doc.data().setting.idea_loadLimit
        }
        if(doc.data().setting&&doc.data().setting.project_noticeOpen){
          if(doc.data().setting.project_noticeOpen==0) self.project_noticeOpen = true
          else self.project_noticeOpen = false
        }
        if(doc.data().setting&&doc.data().setting.idea_submitOpen){
          if(doc.data().setting.idea_submitOpen) self.idea_submitOpen = true
          else self.idea_submitOpen = false
        }
        if(doc.data().setting&&doc.data().setting.navi_updateDate){
          if(doc.data().setting.navi_updateDate) self.navi_updateDate = true
          else self.navi_updateDate = false
        }
        if(doc.data().setting&&doc.data().setting.idea_thread){
          if(doc.data().setting.idea_thread) self.idea_thread = true
          else self.idea_thread = false
        }
        if(doc.data().setting&&doc.data().setting.idea_thread_admin_only){
          if(doc.data().setting.idea_thread_admin_only) self.idea_thread_admin_only = true
          else self.idea_thread_admin_only = false
        }
        if(doc.data().setting&&doc.data().setting.project_sanka){
          if(doc.data().setting.project_sanka) self.project_sanka = true
          else self.project_sanka = false
        }
        if(doc.data().setting&&doc.data().setting.idea_slider){
          if(doc.data().setting.idea_slider) self.idea_slider = true
          else self.idea_slider = false
        }
        if(doc.data().setting&&doc.data().setting.idea_sliderTitle){
          self.idea_sliderTitle = doc.data().setting.idea_sliderTitle
          self.idea_sliderTitleInput = doc.data().setting.idea_sliderTitle
        }
      }).catch((error) => {
        console.log("Error getting document:", error);
      });
    },
    setting(key,value){
      let val = value, self = this
      console.log(key,value)
      if(key=="project_noticeOpen"){
        if(value) val = 0
        else val = 1
      }
      let collectionA = firebase.firestore().collection("0").doc("config")
      collectionA.set({
        setting: {
          [key]: val
        }
      },{merge:true}).then(function() {
        console.log("Document successfully updated!");
        self.getConfig()
      }).catch(function(error) {
        console.log("Error updating document: ", error);
      });
    },
    set(){
      let id = {
      }
      console.log(JSON.stringify(id))
    },
    setlidmem(id,memuid){
      let self = this
      this.db.collection("0").doc(id).collection("liduser").doc(memuid).set({
        uid: memuid
      }).then(function(docRef) {
        // 保存に成功した時
        //console.log("USERss Document written with ID: ", docRef.id)
        console.log(memuid+"ユーザ登録完了")
        //getMembers()
      }).catch(function(error) {
        // 保存に失敗した時
        console.log(memuid+"ユーザ登録失敗")
      })
    },
    getPj(lidname) { //最初にプロジェクト取得
      let self = this
      this.projects = []
      console.log("getpj")
      // 全件取得する
      let collection = this.db.collection("0").doc(lidname).collection("project").where("isActive", "==", true).orderBy('sort','desc')
      collection.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          self.projects.push(doc.id)
          let admin = doc.data().pjadmins
          //self.setpjadmins(lidname,doc.id,admin)
        })
        console.log(`"projects:"+${self.projects}`)
      })
    },
    getvote(){ //投票情報取得(委任可否、クアドラ可否、投票数、)
      let self = this
      console.log("投票情報取得実施")
      //Firebaseから投票情報取得
      let collection = this.db.collection("0").doc("テスト2").collection("project").doc("Qq1aZVIvk3KAJZQfTYcU").collection("referendums")
      collection.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          //console.log(`投票：${doc.id} => ${doc.data()}`)
          this.referendum.push(doc.data())
          console.log("投票情報取得　クアドラ実施："+this.referendum[0].isquavote+this.referendum[0].qmap)
          this.isDele = this.referendum[0].isDelegation //委任可否情報収納
          this.admitq = this.referendum[0].isquavote  //クアドラ可否情報収納
          if(this.admitq&&this.referendum[0].qn1[0]){
            this.qn1 = this.referendum[0].qn1[0]
            this.qn2 = this.referendum[0].qn2[0]
            this.qn3 = this.referendum[0].qn3[0]
            this.qn4 = this.referendum[0].qn4[0]
          }
          console.log("投票情報取得ほぼ終了",this.referendum[0].qn1,typeof Object.keys(this.referendum[0].qn1),typeof this.referendum[0].qn1)
          let self = this
          let q1 = 0,q2 = 0,q3 = 0,q4 = 0
          
          Object.keys(this.referendum[0].qn1).forEach(el => {
            q1 = q1 + this.referendum[0].qn1[el]
            console.log(q1,this.referendum[0].qn1[el])
          })
          Object.keys(this.referendum[0].qn2).forEach(el => {
            q2 = q2 + this.referendum[0].qn2[el]
          })
          Object.keys(this.referendum[0].qn3).forEach(el => {
            q3 = q3 + this.referendum[0].qn3[el]
          })
          Object.keys(this.referendum[0].qn4).forEach(el => {
            q4 = q4 + this.referendum[0].qn4[el]
          })
          console.log("クアドラ結果："+q1,q2,q3,q4)
        })
      })
      console.log("おわり")
    },
    setpjadmins(lidname,pjname,admin){
      this.db.collection("0").doc(lidname).collection("project").doc(pjname).collection("user").doc("admin").set({
        pjadminuid: firebase.firestore.FieldValue.arrayUnion(...Object.keys(admin)),
      }).then(function(docRef) {
        // 保存に成功した時
        //console.log("USERs Document written with ID: ", docRef.id)
        console.log("PJユーザ登録完了")
      }).catch(function(error) {
        // 保存に失敗した時
        console.error("PJユーザ登録失敗: ", error)
      })
    },
    DoAdmin1(){
      let self = this
      this.lid = []
      // 全件取得する
      let collection = this.db.collection("0").where("config","==",true)
      collection.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          console.log(`${doc.id} => ${doc.data()}`)
          let config = doc.data()
          self.conmem = config.members
          self.conadm = config.admins
          console.log("getlid:"+Object.keys(self.conmem))
          console.log("updated",self.conmem,self.conadm)
        })
      })
    },
    DoAdmin11(){
      let self = this
      this.lid = []
      // 全件取得する
      let collection = this.db.collection("0").where("config","==",false)
      collection.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          console.log(`${doc.id} => ${doc.data()}`)
          self.lidid.push(doc.id)
          if(doc.data().admins) self.lididadmin[doc.id] = Object.keys(doc.data().admins)[0]
        })
        self.DoAdmin22()
      })
    },
    DoAdmin22(){
      let self = this
      this.lidid.forEach((el) => {
        if(self.lididadmin[el]){
          this.db.collection("0").doc(el).update({
            'preview.lidAdmin': self.lididadmin[el],
            'preview.disPj': "議論のプロジェクト",
            'preview.votePj': "投票のプロジェクト",
          }).then(function(docRef) {
            // 保存に成功した時
            //console.log("USERss Document written with ID: ", docRef.id)
            console.log("ユーザ登録完了")
            //getMembers()
          }).catch(function(error) {
            // 保存に失敗した時
          })           
        }
       
      })
    },
    DoAdmin2(){
      let self = this
      this.db.collection("0").doc("config").collection("members").doc("admin").update({
        govadmin: firebase.firestore.FieldValue.arrayUnion(...Object.keys(self.conadm))
      }).then(function(docRef) {
        // 保存に成功した時
        //console.log("USERss Document written with ID: ", docRef.id)
        console.log("ユーザ登録完了")
        //getMembers()
      }).catch(function(error) {
        // 保存に失敗した時
      })
    },
    DoAdmin3(){
      let self = this
      this.lid = []
      // 全件取得する
      let collection = this.db.collection("0").doc("config").collection("members").where("admin","==",true)
      collection.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          let ADMIN = doc.data()
          console.log("updated3",ADMIN.adminuid)
        })
      })
    },
    // liduser に isPermitDele : true を追加
    setLid1(){
      let lidusers = {}, pjid = [], i = 0, j = 0
      const self = this

      this.lid.forEach((lidid) => {
        console.log("Lidisdele",lidid)
        this.db.collection("0").doc(lidid).collection("liduser").get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            if(doc.id!=="admin") lidusers[i].push(doc.id)
          })
          i++
          console.log("lidusers",lidid,lidusers)   
          this.db.collection("0").doc(lidid).collection("project").get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              pjid.push(doc.id)
            })
            console.log("pjids",pjid)
            pjid.forEach((pjel)=>{
              console.log("pjel",pjel)
              lidusers[j].forEach((el)=>{
                this.db.collection("0").doc(lidid).collection("project").doc(pjel).collection("user").doc(el).set({
                  isPermitDele: false,
                  uid: el
                },{merge:true}).then(function(docRef) {
                    //console.log("USERs Document written with ID: ", docRef.id)
                    console.log("PJユーザ登録完了")
                }).catch(function(error) {
                    console.error("PJユーザ登録失敗: ", error)
                    alert("Error!:"+error)
                })  
                j++            
              })
            })          
          })
          lidusers = []
          pjid = []
        })
      })      
    },
    // liduser に isPermitDele : true を追加
    setLid2(){
      let lidusers = [],i = 0
      const self = this

      this.lid.forEach((lidid) => {
        console.log("Lidisdele",lidid)
        firebase.firestore().collection("0").doc(lidid.id).collection("liduser").get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            if(doc.id!=="admin") lidusers.push(doc.id)
          })
          i++
          console.log("pjel",lidusers)
 
          lidusers.forEach((el)=>{
            this.db.collection("0").doc(lidid.id).collection("liduser").doc(el).set({
              isActive: true,
            },{merge:true}).then(function(docRef) {
                //console.log("USERs Document written with ID: ", docRef.id)
                console.log("PJユーザ登録完了")
            }).catch(function(error) {
                console.error("PJユーザ登録失敗: ", error)
                alert("Error!:"+error)
            })
          })
          lidusers = []
        })
      })
    },
    addSortToIdea(){
      let self = this
      
      let lidId = []
      // 全件取得する
      this.lid.forEach((el)=>{
        console.log(el.id)
        lidId.push(el.id)
      })
      console.log(this.lid,lidId)

      let idea = []
      lidId.forEach((lidid) => {
        console.log("Lidisdele",lidid)
        firebase.firestore().collection("0").doc(lidid).collection("idea").where("isActive", "==", true).get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let oneidea = doc.data()
            self.$set(oneidea,"id",doc.id)
            idea.push(oneidea)
          })
          console.log("idea",idea)
          idea.forEach((el)=>{
              console.log(el.id,el.date)
              firebase.firestore().collection("0").doc(lidid).collection("idea").doc(el.id).set({
                isHidden: false,
              },{merge:true}).then(function(docRef) {
                //console.log("USERs Document written with ID: ", docRef.id)
                console.log("ideasort登録完了")
              }).catch(function(error) {
                console.error("ideasort登録失敗: ", error)
                //alert("Error!:"+error)
              })              
          })
          idea = []
        })
      })
    },
    addSortToIdea2(){
      let self = this
      let lidId = []
      // 全件取得する
      this.lid.forEach((el)=>{
        console.log(el.id)
        lidId.push(el.id)
      })
      console.log(this.lid,lidId)

      let idea = []
      lidId.forEach((lidid) => {
        console.log("Lidisdele",lidid)
        firebase.firestore().collection("0").doc(lidid).collection("idea").where("isActive", "==", true).where("isHidden", "==", false).get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let oneidea =  doc.data()
            oneidea["id"] = doc.id
            idea.push(oneidea)
          })
          console.log("idea",idea)
          idea.forEach((el)=>{
            let tcolor = ""
            let ttitle = ""
            let isT = false
            if(el.postcolor=="green"){
              tcolor = "#54E363"
              ttitle = "課題を克服する「○○力」"
              isT = true
            }
            else if(el.postcolor=="yellow"){
              tcolor = "#FFB336"
              ttitle = "魅力を活かす「○○力」"
              isT = true
            }
            if(isT){
              console.log(el.id,isT,el,el.postcolor,ttitle,tcolor)
              firebase.firestore().collection("0").doc(lidid).collection("idea").doc(el.id).set({
                tag: {
                  color: tcolor,
                  title: ttitle
                },
              },{merge:true}).then(function(docRef) {
                //console.log("USERs Document written with ID: ", docRef.id)
                console.log("idea登録完了")
              }).catch(function(error) {
                console.error("idea登録失敗: ", error)
                //alert("Error!:"+error)
              })              
            }
          })
          idea = []
        })
      })
    }
  }
}
</script>